var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5158_5432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5H2.91667H12.25",
    stroke: "#FDA29B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 3.50001V2.33334C4.66797 2.02392 4.79089 1.72717 5.00968 1.50838C5.22847 1.28959 5.52522 1.16667 5.83464 1.16667H8.16797C8.47739 1.16667 8.77413 1.28959 8.99293 1.50838C9.21172 1.72717 9.33464 2.02392 9.33464 2.33334V3.50001M11.0846 3.50001V11.6667C11.0846 11.9761 10.9617 12.2728 10.7429 12.4916C10.5241 12.7104 10.2274 12.8333 9.91797 12.8333H4.08464C3.77522 12.8333 3.47847 12.7104 3.25968 12.4916C3.04089 12.2728 2.91797 11.9761 2.91797 11.6667V3.50001H11.0846Z",
    stroke: "#FDA29B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 6.41667V9.91667",
    stroke: "#FDA29B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 6.41667V9.91667",
    stroke: "#FDA29B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5158_5432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconDisabled);
export default __webpack_public_path__ + "static/media/delete_icon_disabled.5430b41935e3595a12268394352b825f.svg";
export { ForwardRef as ReactComponent };